import React from 'react';
import T from 'prop-types';
// utils
import classnames from 'classnames/bind';
// styles
import styles from './SegmentedTabs.module.scss';

const cn = classnames.bind(styles);

// Segmented view switcher with optional count badges (e.g. Pig Movements | Treatments)
const SegmentedTabs = ({ options, value, onChange, className }) => (
  <div className={cn('segmented-tabs', { [className]: !!className })}>
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        className={cn('tab', { active: value === option.value })}
        onClick={() => onChange(option.value)}
        onMouseDown={(e) => e.preventDefault()} // mouse clicks should not leave a lingering focus ring
      >
        <span className={cn('tab-label')}>{option.label}</span>
        {Boolean(option.counter) && <span className={cn('counter-badge')}>{option.counter}</span>}
      </button>
    ))}
  </div>
);

SegmentedTabs.propTypes = {
  options: T.arrayOf(T.shape({
    value: T.string.isRequired,
    label: T.node.isRequired,
    counter: T.number,
  })).isRequired,
  value: T.string.isRequired,
  onChange: T.func.isRequired,
  className: T.string,
};

export default SegmentedTabs;
